import {
  NavigateOptions,
  To,
  useLocation,
  useNavigate as useNavigateBase,
  useOutletContext,
  resolvePath,
  Location,
  useMatch,
} from "react-router-dom";
import { mergeLocation, mergeSearch } from "utils/NavigationUtils";
import { OutlextContext, AppOutlextContext } from "../types";

export function useNavigate() {
  const location = useLocation();
  const navigateBase = useNavigateBase();
  const matches = useMatch({ caseSensitive: false, path: "/" });
  function navigate(to: To, options?: NavigateOptions) {
    return navigateBase(getMergedLocation(to, location), options);
  }

  return navigate;
}

function getMergedLocation(to: To, location: Location) {
  const currrentPathName =
    location.pathname &&
    typeof to === "string" &&
    location.pathname.endsWith(`/${to}`)
      ? location.pathname.substring(
          0,
          location.pathname.length - (to.length + 1)
        )
      : location.pathname;
  const path = resolvePath(
    to,
    typeof to === "string" && !to.startsWith("/") ? currrentPathName : undefined
  );

  const mergedSearch = mergeSearch(path, location);
  const mergedLocation = mergeLocation(to, path, location, mergedSearch);

  return mergedLocation;
}

export const useLayoutContext = () => {
  return useOutletContext<OutlextContext>();
};

export const useAppLayoutContext = () => {
  return useOutletContext<AppOutlextContext>();
};
